import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col overflow-x-clip'>
            <a
                href='#main'
                className='sr-only rounded-full bg-gold px-5 py-2.5 text-sm font-medium text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[120]'
            >
                Skip to content
            </a>

            <Header />

            <main id='main' tabIndex={-1} className='flex-1 outline-none'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
